import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
const CustomBox = styled(Box)(({ theme }) => ({
  padding: "0px",
  width: "100%",
  height: "100%",
  backgroundColor: theme.palette.background.paper,
}));
export default CustomBox;
